module.exports = __webpack_public_path__ + "ear-right@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/ear-right@2x.png
// module id = 140
// module chunks = 0